<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">{{$t('Videos.Robustagno')}}</h1>
          <h2 class="page-subtitle">{{ totalCount }} {{ totalCount === 1 ? $t('video') : $t('videos')}}</h2>
        </div>
        <b-button variant="primary" @click="clickOnCreateBtn" v-if="allowCreate">
          <plus-icon size="18" class="mr-1" /> {{$t('Add')}} {{$t('a.e')}} {{$t('video')}}
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableVideo"
          identifier="B122TableVideo"
          get-b122-table-results-url="/resource/getB122TableResults?restrictbyboolean-robustagnoVideo=True"
          :fields="tableFields"
          :editItem=allowEdit
          :deleteItem=allowDelete
          :empty-title="$t('video.emptyTitle').toString()"
          :empty-text="$t('video.emptyText').toString()"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn">

          <template #cell(urlLink)="data">
            <div v-if="isValidUrl(data.item.urlLink)"
              class="custom-link"
              @click="clickOnOpenUrl(data.item.urlLink)">
              {{ data.item.urlLink }}
            </div>
            <div v-else>
              {{ data.item.urlLink }}
            </div>
          </template>

          <template #cell(show)="row">
            <button class="ph-btn action-btn flex-row justify-content-center align-items-center" :disabled="row.item.resourceType !== 'FILE'"
                    @click="clickOnDownloadBtn(row.item.fileRobustagno.fileUrl)" v-if="allowDownload">
              <i class="ph-custom ph-download-fill"/>
            </button>
          </template>

          <template #cell(actions)="data">
            <div class="actions-container text-right" >
              <button class="action-btn edit mr-1" @click="clickOnEditBtn(data)" v-if="allowEdit">
                <i class="ph-custom ph-pencil-simple-line-fill"/>
              </button>
              <button class="action-btn delete" @click="clickOnDeleteBtn(data)" v-if="allowDelete && !(data.item.nbSheetLinked&&data.item.nbSheetLinked>0)">
                <i class="ph-custom ph-trash-fill"/>
              </button>
            </div>
          </template>
        </b122-table>
      </b-card>
    </b-container>

    <Item-delete-modal
      :beginsWithVoyel="false"
      :isFeminine="true"
      :selectedItem="selectedItem"
      controllerName="resource"
      itemSingularName="resource"
      itemSingularNameUpp="Resource"
      @didDeleteItem="didDeleteItem()">
    </Item-delete-modal>

  </div>
</template>

<script>

import B122Table from '../../components/b122/B122Table'
import ItemDeleteModal from '../../components/b122/ItemDeleteModal'
import api from "../../services/api";
export default {

  name: 'VideoIndex',

  components: {
    B122Table,
    ItemDeleteModal
  },

  data () {
    let isAuthorized = this.$store.getters.isSuperAdmin || this.$store.getters.isAdmin
    return {

      totalCount: 0,
      allowCreate: isAuthorized,
      allowDelete: isAuthorized,
      allowEdit: isAuthorized,
      allowDownload: isAuthorized,
      selectedItem: null
    }
  },

  computed: {

    tableFields () {
      return [
        {
          label: '',
          key: 'show',
          sortable: false
        },
        {
          label: this.$i18n.t('Video.title'),
          key: 'title',
          sortable: true
        },
        {
          label: this.$i18n.t('Resource.sheets.linked'),
          key: 'sheetsLinked',
          sortable: false
        },
        {
          label: '',
          key: 'actions'
        }
      ]
    }

  },

  methods: {

    resourceTrad (value) {
      return this.$i18n.t(value)
    },

    setTotalCount (totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn () {
      this.$router.push({
        name: 'VideoCreate'
      })
    },

    clickOnShowBtn (row) {
      this.$router.push({
        name: 'VideoShow',
        params: {
          videoId: row.item.id
        }
      })
    },

    clickOnEditBtn (row) {
      this.$router.push({
        name: 'VideoEdit',
        params: {
          videoId: row.item.id
        }
      })
    },

    clickOnDeleteBtn (row) {
      this.selectedItem = row.item
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteItem () {
      this.selectedItem = null
      this.$refs.B122TableVideo.refreshTable()
    },

    isValidUrl (url) {
      const regex = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/
      return regex.test(url)
    },

    clickOnOpenUrl (url) {
      window.open(url, '_blank').focus()
    },

    async clickOnDownloadBtn (fileUrl) {
      const res = await api.get(fileUrl, {
        responseType: 'blob'
      })

      var disposition = res.headers['content-disposition'] || ''
      var filename = 'download'

      if (disposition) {
        var match = disposition.match(/filename="?([^"]+)"?/i)
        if (match && match[1]) {
          filename = match[1]
        }
      }

      var blobUrl = window.URL.createObjectURL(res.data)
      var a = document.createElement('a')
      a.href = blobUrl
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(blobUrl)
    }

  }
}
</script>

<style scoped>

.custom-link{
  color: var(--main-black);
  cursor: pointer;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/videoRobustagno/VideoIndex.vue